import React from "react";
import { useTheme } from "@emotion/react";
import { 
    ContainerPrimary, 
    TextPrimary,
    LinkPrimary 
} from "../styles/styledComponents";
import { AppBar } from "@mui/material";
import { Container } from "@mui/system";

const headerHeight = 100;

export default function Header() {
    const theme = useTheme();
    return (<>
        <AppBar>
            <ContainerPrimary
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: headerHeight,
                    width: "100%",
                }}
            >
            <TextPrimary variant="h4">Proxy Configuration</TextPrimary>
            <LinkPrimary>
                Demo Account
            </LinkPrimary>
        </ContainerPrimary>
        </AppBar>
        <Container sx={{height: headerHeight}}></Container>
    </>)
}
